<template>
  <section class="tcol" :aria-label="title">
    <header class="tcol__head">
      <span class="tcol__dot" :class="`tcol__dot--${tone}`"></span>
      <span class="tcol__title">{{ title }}</span>
      <span class="tcol__count">{{ cards.length }}</span>
    </header>
    <div class="tcol__body">
      <TaskCard
        v-for="card in cards"
        :key="card.id"
        :card="card"
        :pending="pendingIds.includes(card.id)"
        :disabled="disabled"
        @edit="$emit('edit', $event)"
        @cancel="$emit('cancel', $event)"
        @reopen="$emit('reopen', $event)"
        @resume="$emit('resume', $event)"
        @focus="$emit('focus', $event)"
      />
      <div v-if="cards.length === 0" class="tcol__empty">Задач нет</div>
    </div>
  </section>
</template>

<script>
import TaskCard from './TaskCard.vue';

/** One board column (KOP-38 spec §6.4): header with count, cards, or «Задач нет». Dumb. */
export default {
  name: 'TrackerColumn',
  components: { TaskCard },
  props: {
    title: { type: String, required: true },
    tone: { type: String, default: 'grey', validator: (v) => ['grey', 'green', 'amber', 'red'].includes(v) },
    cards: { type: Array, default: () => [] },
    pendingIds: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
};
</script>

<style scoped lang="scss">
.tcol { flex: 1 1 0; min-width: 320px; display: flex; flex-direction: column; min-height: 0; background: #f4f5f1; border: 1px solid #e3e5e1; border-radius: 10px; }
.tcol__head { display: flex; align-items: center; gap: 8px; padding: 10px 12px; font-weight: 700; font-size: 13px; color: #1d221f; border-bottom: 1px solid #e3e5e1; }
.tcol__dot { width: 8px; height: 8px; border-radius: 50%; }
.tcol__dot--grey { background: #8b918c; }
.tcol__dot--green { background: #17876f; }
.tcol__dot--amber { background: #d99a2b; }
.tcol__dot--red { background: #c0492b; }
.tcol__count { background: #e3e5e1; color: #4c524d; font-size: 11.5px; padding: 1px 7px; border-radius: 9px; }
.tcol__body { flex: 1; min-height: 0; overflow: auto; padding: 10px; display: flex; flex-direction: column; gap: 10px; }
.tcol__empty { color: #8b918c; font-size: 13px; text-align: center; padding: 18px 0; }
</style>
